
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prometheus-nft",
      function () {
        return require("private-next-pages/prometheus-nft/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prometheus-nft"])
      });
    }
  